import React from 'react';
import { ListItem } from '@bb-ui/react-library/dist/components/ListItem';
import { ListItemText } from '@bb-ui/react-library/dist/components/ListItemText';
import { ListItemIcon, createStyles, makeStyles } from '@bb-ui/react-library';
import { Information } from '@bb-ui/icons/dist/medium';

import { JobCardList } from './basic/JobCardList';
import { ExecutionDetailResponseBody } from '@lct-jobs/core';

const useStyles = makeStyles(() =>
  createStyles({
    listItem: {
      paddingTop: 6,
      paddingBottom: 6,
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.02)',
      },
    },
    jobName: {
      fontSize: '14px',
      fontWeight: 500,
    },
    jobDescription: {
      fontSize: '13px',
      color: 'rgba(0, 0, 0, 0.55)',
      marginTop: 2,
    },
  }),
);

export interface JobRegistrationPropsBox {
  jobExecution?: ExecutionDetailResponseBody;
  detailsLoading?: boolean;
  siteDetailsLoading?: boolean;
}

export const RegistrationBox: React.FC<JobRegistrationPropsBox> = (props) => {
  const classes = useStyles();
  const execution = props.jobExecution;
  const loadingDetails = props.detailsLoading;
  const { siteDetailsLoading } = props;
  return (
    <JobCardList
      title="Job Information"
      subtitle={execution?.jobId ? `Job ID: ${execution?.jobId}` : undefined}
      loading={loadingDetails || siteDetailsLoading}
    >
      <ListItem className={classes.listItem}>
        <ListItemIcon>
          <Information />
        </ListItemIcon>
        <ListItemText
          primary={<span className={classes.jobName}>{execution?.jobName}</span>}
          secondary={
            <span className={classes.jobDescription}>{execution?.jobConfig?.jobDescription}</span>
          }
        />
      </ListItem>
      {execution?.tenantId && (
        <ListItem className={classes.listItem}>
          <ListItemIcon>
            <Information />
          </ListItemIcon>
          <ListItemText primary="Tenant ID" secondary={execution.tenantId} />
        </ListItem>
      )}
      {execution?.tenantType && (
        <ListItem className={classes.listItem}>
          <ListItemIcon>
            <Information />
          </ListItemIcon>
          <ListItemText primary="Tenant Type" secondary={execution.tenantType} />
        </ListItem>
      )}
      {execution?.region && (
        <ListItem className={classes.listItem}>
          <ListItemIcon>
            <Information />
          </ListItemIcon>
          <ListItemText primary="Region" secondary={execution.region} />
        </ListItem>
      )}
      {execution?.jobVersion !== undefined && (
        <ListItem className={classes.listItem}>
          <ListItemIcon>
            <Information />
          </ListItemIcon>
          <ListItemText primary="Job Version" secondary={String(execution.jobVersion)} />
        </ListItem>
      )}
      {execution?.jobDomain && (
        <ListItem className={classes.listItem}>
          <ListItemIcon>
            <Information />
          </ListItemIcon>
          <ListItemText primary="Domain" secondary={execution.jobDomain} />
        </ListItem>
      )}
    </JobCardList>
  );
};
